import React from 'react';
import styled from '../../styled';
import Theme from '../../themes/index';
export const StyledSvg = styled.svg `
  fill: ${({ color }) => color};
`;
export const logoGenerator = (Component) => ({ color = 'INK_600' }) => React.createElement(Component, { color: Theme.colors[color] });
//# sourceMappingURL=logo.js.map